export class ReportItem {
    text: string;
    value: string;
    value2: string;

    static fromJson(dict: any): ReportItem {
        let r = new ReportItem();
        return r.fromJson(dict);
    }

    fromJson(dict: any): ReportItem {
        this.text = dict.text;
        this.value = dict.value;
        this.value2 = dict.value2;
        return this;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/report-item.ts